import DepartureStationFilter
    from "@SearchResults/features/sidebar/features/stationFilters/components/DepartureStationFilter";
import DestinationStationFilter
    from "@SearchResults/features/sidebar/features/stationFilters/components/DestinationStationFilter";
import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import useActiveTabFromParams from "@SearchResults/hooks/useActiveTabFromParams";
import ParamsType from "@SearchResults/types/params/Params.type";

type StationFiltersProps = {
    searchData: SearchResultsRtkQueryResponseType,
    params?: ParamsType
}

function StationFilters({searchData, params}: StationFiltersProps) {
    const activeTab = useActiveTabFromParams()

    return (
        <>
            <DepartureStationFilter
                activeTab={activeTab}
                searchData={searchData}
                params={params}
            />
            <DestinationStationFilter
                activeTab={activeTab}
                searchData={searchData}
                params={params}
            />
        </>
    );
}

export default StationFilters;